var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheepSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.02 205.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7cbc1;}.cls-2,.cls-3{fill:#dfefe9;}.cls-3{stroke:#060910;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4.49px;}.cls-4{fill:#5a9b5f;}.cls-5{fill:#060910;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m219.26,156.77l2.48-5.27s-4.78,1.64-5.45,3.78-1.31-5.77,1.34-9.56-6.44,6.58-6.61,9.38.67-3.3-3.29-4.46c0,0,1.64,3.3-.01,5.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m287.17,161.87l1.75-3.73s-3.38,1.16-3.85,2.67-.92-4.08.94-6.76-4.55,4.65-4.67,6.63.47-2.33-2.32-3.15c0,0,1.16,2.33,0,4.08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m258.46,176.64s-1.08-3.96,0-9.72c0,0-2.61,3.19-4.18,7.74-.12.36-.64.32-.69-.06-.68-5.21-3.29-20.64-9.88-18.84,0,0,6.48,10.44.36,19.08,0,0-2.88-3.96-2.16-6.48s-3.24,5.04-3.24,6.84-3.24-5.76-4.68-3.96c0,0,2.52,4.68-.36,6.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 175.71,
    y: 125.19,
    width: 10.26,
    height: 50.84,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(361.68 301.23) rotate(-180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 162.71,
    y: 122.46,
    width: 10.26,
    height: 50.84,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(335.69 295.76) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 121.11,
    y: 124.17,
    width: 10.26,
    height: 50.84,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(252.47 299.18) rotate(-180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 104.92,
    y: 125.08,
    width: 10.26,
    height: 50.84,
    rx: 2.7,
    ry: 2.7,
    transform: "translate(220.1 301) rotate(-180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "sheep_body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m73.23,100.8c0-10.74,6.86-19.86,16.43-23.28,3.1-8.68,10.9-15.12,20.35-16.24,3.11-10.11,12.52-17.46,23.65-17.46,6.48,0,12.36,2.51,16.77,6.58,2.98-1.27,6.26-1.98,9.71-1.98,6.63,0,12.63,2.62,17.07,6.86,3.87-2.51,8.48-3.98,13.43-3.98,13.67,0,24.75,11.08,24.75,24.75,0,3.93-.94,7.63-2.57,10.94.23.37.46.73.67,1.1,7.33,4.3,12.26,12.23,12.26,21.34,0,13.35-10.57,24.2-23.8,24.7-3.33,9.73-12.54,16.74-23.4,16.74-6.03,0-11.55-2.16-15.84-5.74-.8.08-1.61.16-2.42.22-4.27,7.42-12.27,12.43-21.44,12.43-7.01,0-13.33-2.93-17.83-7.61-1.85.44-3.78.7-5.77.7-13.67,0-24.75-11.08-24.75-24.75,0-.57.05-1.14.09-1.7-10.05-3.15-17.35-12.53-17.35-23.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m106.22,89.19s13.05,5.13,10.18,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m166.13,87.01s-12.31,17.78-26.9,1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m179.92,118.14s-10.31,5.71-18.67-4.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.01,61.28s8.02-1.86,13.15,3.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m118.83,150.27s11.63-3.42,12.31-12.99"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 76.88,
    cy: 109.01,
    rx: 9.4,
    ry: 3.93,
    transform: "translate(-56.46 105.41) rotate(-53.26)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "sheep_head",
    id: "sheephead"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "test1",
    className: "cls-5",
    cx: 221.19,
    cy: 84.84,
    rx: 14.82,
    ry: 22.34,
    transform: "translate(8.78 189.76) rotate(-47.27)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 200.96,
    cy: 85.7,
    rx: 8.89,
    ry: 3.42,
    transform: "translate(3.17 178.47) rotate(-48.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2 sheep_eyes",
    cx: 220.51,
    cy: 79.21,
    r: 1.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 219.54,
    cy: 91.73,
    rx: 5.77,
    ry: 7.6,
    transform: "translate(26.39 230.68) rotate(-58.41)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5 sheep_jaw",
    cx: 222.3,
    cy: 97.19,
    rx: 3.25,
    ry: 9.15,
    transform: "translate(16.97 226.43) rotate(-55.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheepSvg);
export default __webpack_public_path__ + "static/media/SheepSvg.117e8eb7ce60dcb991f3ffbba46ed952.svg";
export { ForwardRef as ReactComponent };